import React from 'react'
import { cx } from '@/lib/utils'
import styles from './CoverImage.module.scss'

type AspectRatio = '16/9' | '2/1'

interface CoverImageProps {
  src: string
  alt: string
  aspectRatio?: AspectRatio
  framed?: boolean
}

const ratioMap: Record<AspectRatio, string> = {
  '16/9': styles.ratio16x9, '2/1': styles.ratio2x1,
}

export const CoverImage: React.FC<CoverImageProps> = ({
  src, alt, aspectRatio = '16/9', framed = false,
}) => (
  <figure className={cx(styles.figure, ratioMap[aspectRatio], framed && styles.framed)}>
    <img src={src} alt={alt} className={styles.image} loading="lazy" />
  </figure>
)
